export const ReviewList = {
  flow: 'y',
  gap: 'A',
  width: '100%',

  state: {
    reviewFilter: 'recent',
    reviews: [
      {
        patientName: 'Nino M.',
        date: 'Mar 12, 2026',
        rating: 5,
        text: 'Absolutely wonderful experience. Dr. Kvaratskhelia explained every step of my root canal procedure clearly and made sure I was comfortable throughout. Highly recommend!',
        categories: { professionalism: 5, painManagement: 5, explanationQuality: 5, punctuality: 4 },
        doctorResponse: 'Thank you, Nino! We always strive to make every patient feel at ease. Looking forward to your next check-up.',
        helpfulCount: 12,
        notHelpfulCount: 1
      },
      {
        patientName: 'Giorgi T.',
        date: 'Mar 5, 2026',
        rating: 4,
        text: 'Great clinic with modern equipment. Wait time was a bit longer than expected but the treatment quality was excellent. The staff was very professional and friendly.',
        categories: { professionalism: 5, painManagement: 4, explanationQuality: 4, punctuality: 3 },
        helpfulCount: 8,
        notHelpfulCount: 0
      },
      {
        anonymous: true,
        date: 'Feb 28, 2026',
        rating: 5,
        text: 'Best dental experience I have ever had. The pain management during my wisdom tooth extraction was incredible - I barely felt anything. Will definitely come back.',
        categories: { professionalism: 5, painManagement: 5, explanationQuality: 4, punctuality: 5 },
        helpfulCount: 15,
        notHelpfulCount: 2
      },
      {
        patientName: 'Mariam K.',
        date: 'Feb 20, 2026',
        rating: 3,
        text: 'Decent service overall. The cleaning was thorough but the appointment started 20 minutes late. Communication about delays could be improved.',
        categories: { professionalism: 4, painManagement: 3, explanationQuality: 3, punctuality: 2 },
        doctorResponse: 'We apologize for the delay, Mariam. We are working on improving our scheduling to minimize wait times.',
        helpfulCount: 6,
        notHelpfulCount: 3
      },
      {
        patientName: 'Luka B.',
        date: 'Feb 10, 2026',
        rating: 5,
        text: 'Outstanding professionalism. Dr. Datunashvili took extra time to explain my treatment options and helped me choose the best plan for my budget. Five stars all around.',
        categories: { professionalism: 5, painManagement: 5, explanationQuality: 5, punctuality: 5 },
        helpfulCount: 20,
        notHelpfulCount: 0
      }
    ]
  },

  FilterBar: {
    flow: 'x',
    gap: 'Y',
    align: 'center flex-start',
    marginBottom: 'Y',

    FilterLabel: { text: '{{ sortBy | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', marginRight: 'Y' },

    RecentPill: {
      text: '{{ recent | polyglot }}',
      fontSize: 'Y',
      fontWeight: '500',
      padding: 'W Z',
      round: 'C',
      cursor: 'pointer',
      transition: 'all 0.15s ease',
      background: (el, s) => s.root.reviewFilter === 'recent' ? 'teal' : 'inkSurface',
      color: (el, s) => s.root.reviewFilter === 'recent' ? 'ink' : 'inkSubtle',
      onClick: (e, el, s) => s.root.update({ reviewFilter: 'recent' })
    },

    HighestPill: {
      text: '{{ highest | polyglot }}',
      fontSize: 'Y',
      fontWeight: '500',
      padding: 'W Z',
      round: 'C',
      cursor: 'pointer',
      transition: 'all 0.15s ease',
      background: (el, s) => s.root.reviewFilter === 'highest' ? 'teal' : 'inkSurface',
      color: (el, s) => s.root.reviewFilter === 'highest' ? 'ink' : 'inkSubtle',
      onClick: (e, el, s) => s.root.update({ reviewFilter: 'highest' })
    },

    LowestPill: {
      text: '{{ lowest | polyglot }}',
      fontSize: 'Y',
      fontWeight: '500',
      padding: 'W Z',
      round: 'C',
      cursor: 'pointer',
      transition: 'all 0.15s ease',
      background: (el, s) => s.root.reviewFilter === 'lowest' ? 'teal' : 'inkSurface',
      color: (el, s) => s.root.reviewFilter === 'lowest' ? 'ink' : 'inkSubtle',
      onClick: (e, el, s) => s.root.update({ reviewFilter: 'lowest' })
    }
  },

  ReviewItems: {
    flow: 'y',
    gap: 'Z',
    width: '100%',
    childExtends: 'ReviewCard',
    childrenAs: 'state',
    children: (el, s) => {
      const reviews = [...(s.reviews || [])]
      const filter = s.root.reviewFilter || 'recent'
      if (filter === 'highest') reviews.sort((a, b) => b.rating - a.rating)
      else if (filter === 'lowest') reviews.sort((a, b) => a.rating - b.rating)
      return reviews
    }
  }
}
